import {action, computed, observable, makeObservable} from 'mobx';

class FeedbackDialog {
  @observable
  canDiscard = false;

  @observable
  feedbackText = '';

  @observable
  isTryAgainErrorDialogOpen = false;

  @observable
  isSaveWithoutNewImageDialogOpen = false;

  @observable
  isRemoveImageDialogOpen = false;

  @observable
  isUploading = false;

  @observable
  mediaUploadErrorText = '';

  @observable
  mediaUrl = '';

  @observable
  onDiscardDialogClose;

  @observable
  stepId;

  constructor() {
    makeObservable(this);
  }

  @computed
  get canNavigateAway() {
    const hasPendingInput = this.hasChanges || this.isUploading;
    return !hasPendingInput || this.canDiscard;
  }

  @computed
  get currentCheck() {
    return this.store.checklist.checklist[this.stepId];
  }

  @computed
  get hasChanges() {
    if (this.currentCheck) {
      return this.feedbackText !== this.currentCheck.feedbackText || this.mediaUrl !== this.currentCheck.mediaUrl;
    }

    return Boolean(this.feedbackText || this.mediaUrl);
  }

  @computed
  get isDiscardDialogOpen() {
    return Boolean(this.onDiscardDialogClose);
  }

  @action
  init = stepId => {
    this.reset();
    this.stepId = stepId;

    if (this.currentCheck) {
      this.feedbackText = this.currentCheck.feedbackText;
      this.mediaUrl = this.currentCheck.mediaUrl;
    }
  };

  @action
  openDiscardDialog = onClose => {
    this.onDiscardDialogClose = onClose;
  };

  @action
  reset = () => {
    this.canDiscard = false;
    this.feedbackText = '';
    this.isSaveWithoutNewImageDialogOpen = false;
    this.isTryAgainErrorDialogOpen = false;
    this.isRemoveImageDialogOpen = false;
    this.isUploading = false;
    this.mediaUploadErrorText = '';
    this.mediaUrl = '';
    this.onDiscardDialogClose = undefined;
    this.stepId = undefined;
  };

  @action
  resolveCanDiscard = canDiscard => {
    this.canDiscard = canDiscard;

    if (this.onDiscardDialogClose) {
      this.onDiscardDialogClose();
      this.onDiscardDialogClose = undefined;
    }
  };

  @action
  setFeedbackText = feedbackText => {
    this.feedbackText = feedbackText;
  };

  @action
  setIsUploading = isUploading => {
    this.isUploading = isUploading;
  };

  @action
  setMediaUploadErrorText = errorText => {
    this.mediaUploadErrorText = errorText;
  };

  @action
  setMediaUrl = mediaUrl => {
    this.mediaUrl = mediaUrl;
  };

  @action
  setIsTryAgainErrorDialogOpen = isOpen => {
    this.isTryAgainErrorDialogOpen = isOpen;
  };

  @action
  setIsRemoveImageDialogOpen = isOpen => {
    this.isRemoveImageDialogOpen = isOpen;
  };

  @action
  setIsSaveWithoutNewImageDialogOpen = isOpen => {
    this.isSaveWithoutNewImageDialogOpen = isOpen;
  };

  setStore = store => {
    this.store = store;
  };
}

export default FeedbackDialog;
